import Modal from 'components/Modal'
import CreateMember from 'views/MemberLookup/ManualTx/CreateMember'

const ModalCreateMember = ({
  title,
  open,
  onClose,
}: {
  title: string | undefined
  open: boolean
  onClose: () => void
}): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <CreateMember onClose={onClose} />
    </Modal>
  )
}

export default ModalCreateMember
